import { useEffect } from 'react'
import BottomSheetContent from '../BottomSheetContent'
import { trackEvent } from '../../../utils/appBridge'
import { EventNames } from '../../../types/misc.types'
import RenderHTML from '../../ui-components/RenderHTML'
import { PrimaryButton } from '../../execution/PrimaryButton'

export const PaymentNotCompletedBottomSheet = ({
  onDismiss,
  onStayOnScreen,
  onExitAnyway,
  ScreenName,
  isAutopay = false,
}: {
  onDismiss: () => void
  onStayOnScreen: () => void
  onExitAnyway: () => void
  ScreenName: string
  isAutopay?: boolean
}) => {
  const heading = isAutopay ? 'Autopay setup incomplete' : 'Payment not completed yet'
  const description = isAutopay
    ? "If you go back now, the autopay request will be cancelled and you'll have to set it up again."
    : "If you go back now, the payment request will be cancelled and you'll have to place the order again."

  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: heading,
        ScreenName
      }
    })
  }, [])

  return (
    <BottomSheetContent
      heading=''
      headingComponent={
        <div className='flex flex-col items-start px-5 mb-2 pt-2'>
          <div className='mb-4'>
            <RenderHTML innerHTMLText={WarningIcon} />
          </div>
          <h2 className='text-[22px] font-[500] text-left'>{heading}</h2>
        </div>
      }
      onDismiss={onDismiss}
      bottomSheetHeadingClassName='!font-[500]'
      bottomSheetBodyClassName='!px-0 !pb-3'
      bottomSheetCtas={
        <div className='flex flex-col gap-3'>
          <PrimaryButton
            onClick={onStayOnScreen}
            label='Stay on this screen'
            primaryButtonClassName='!h-14 !text-[16px] !rounded-xl'
          />
          <button
            onClick={onExitAnyway}
            className='w-full py-2 px-4 text-[#232323] font-medium rounded-xl h-14 outline-none focus:outline-none bg-transparent'
          >
            Exit anyway
          </button>
        </div>
      }
    >
      <div className='flex flex-col items-start'>
        <div className='text-[#E77464] text-[14px] font-[500] leading-[150%] text-left px-5'>
          {description}
        </div>
      </div>
    </BottomSheetContent>
  )
}

export const WarningIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
  <path
    d="M30.4763 41.0237C29.8512 41.6487 29.0033 42 28.1193 42H15.8807C14.9967 42 14.1488 41.6487 13.5237 41.0237L2.9763 30.4763C2.3512 29.8512 2 29.0033 2 28.1193V15.8807C2 14.9967 2.3512 14.1488 2.9763 13.5237L13.5237 2.9763C14.1488 2.3512 14.9967 2 15.8807 2H28.1193C29.0033 2 29.8512 2.3512 30.4763 2.9763L41.0237 13.5237C41.6487 14.1488 42 14.9967 42 15.8807V28.1193C42 29.0033 41.6487 29.8512 41.0237 30.4763L30.4763 41.0237Z"
    stroke="#232323"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M22 12.5762V23.8431"
    stroke="#232323"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M21.9967 31.4328C21.5627 31.4328 21.2109 31.081 21.2109 30.647C21.2109 30.2131 21.5627 29.8613 21.9967 29.8613"
    stroke="#232323"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M22 31.4328C22.4339 31.4328 22.7857 31.081 22.7857 30.647C22.7857 30.2131 22.4339 29.8613 22 29.8613"
    stroke="#232323"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>`
